// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class YesNoIndicators {
    public static readonly YES: string = 'Y';
    public static readonly NO: string = 'N';
}
